module.exports = __webpack_public_path__ + "img/z-gruen-dunkel.4aec7ada.svg";